import React from 'react';

import { PhotosScreen } from '~/components/domain/photos/PhotosScreen';

export default function PrivatePhotos() {
  return <PhotosScreen listType="private" />;
}
